<template>
  <header class="spec-project-header" v-bind="$attrs" v-on="$listeners">
    <div class="container">
      <div class="content">
        <div v-stack-y:xs>
          <nav v-if="!readonly">
            <SloLink to="/designspec" v-stack-x:2xs>
              <SloIcon name="ArrowLeft" />
              <span>{{ 'My Projects' | t }}</span>
            </SloLink>
          </nav>
          <h1>
            <SloEditableText
              ref="name"
              v-if="!readonly"
              :placeholder="'My Project' | t"
              @enter="handleEnter()"
              @blur="handleBlur()"
              v-model="projectName"
            />
            <span v-else v-html="projectName" />
          </h1>
        </div>
        <div class="buttons">
          <router-link
            v-if="readonly"
            :to="{ name: 'download', params: this.$route.params }"
            custom
          >
            <SloButton fill="solid">
              <SloIcon name="ArrowDownToLine" />
              <span>{{ 'Download DesignSpec' | t }}</span>
            </SloButton>
          </router-link>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import {mapActions} from 'vuex';
import t from '../../main/i18n';
import SloLink from '../../../lib/components/SloLink.vue';
import SloEditableText from '../../../lib/components/SloEditableText.vue';
import SloIcon from '../../../lib/components/SloIcon.vue';
import SloButton from '../../../lib/components/SloButton.vue';

export default {
  name: 'ProjectHeader',
  components: {
    SloButton,
    SloLink,
    SloEditableText,
    SloIcon
  },
  props: {
    project: {type: Object, default: null},
    readonly: {type: Boolean, default: false}
  },
  filters: {
    t
  },
  data() {
    return {
      initialProjectName: 'My Project'
    };
  },
  mounted() {
    this.initialProjectName = this.project?.name;
  },
  computed: {
    projectName: {
      get() {
        return this.project?.name;
      },
      set(value) {
        this.$store.dispatch('designspec/updateProject', {
          id: this.project.id,
          name: value
        });
      }
    }
  },
  methods: {
    ...mapActions('designspec', ['saveProject']),
    handleEnter() {
      this.$refs.name.blur();
    },
    handleBlur() {
      if (!this.projectName) {
        this.projectName = this.initialProjectName;
        return;
      }
      if (this.projectName !== this.initialProjectName) {
        this.saveProject({id: this.project.id});
        this.initialProjectName = this.projectName;
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../../scss/variables';
@import '../../../scss/system';

.spec-project-header {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: $color-gray-900;
}

.content {
  padding: 16px 0 8px;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

nav {
  display: flex;
  align-items: flex-start;
}

h1 {
  @include text('xl');

  @media screen and (min-width: $screen-sm-min) {
    @include text('2xl');
  }
}

.buttons {
  margin-top: auto;
}
</style>
